<div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">

        <div class="ui-g-12 ui-md-4 ui-sm-12">
            <h2>{{ this.translations.departmentInvoiceTitle }}</h2>
            <div class="chart-container">
                <chart [options]="departmentInvoiceChart.options"
                       (load)="setChartInstance(departmentInvoiceChart, $event.context)"></chart>
            </div>
        </div>

        <div class="ui-g-12 ui-md-8 ui-sm-12">
            <h2>{{ this.translations.divisionDepartmentInvoiceTitle }}</h2>
            <div class="chart-container">
                <chart [options]="divisionDepartmentInvoiceChart.options"
                       (load)="setChartInstance(divisionDepartmentInvoiceChart, $event.context)"></chart>
            </div>
        </div>


    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-category-importance/customer-category-importance.component.html